import HOME_COMPANY from './HOME_COMPANY'
import ADD_CONTACT from './ADD_CONTACT'
import IMPORT_CONTACTS from './IMPORT_CONTACTS'
import RAISE_QUOTE from './RAISE_QUOTE'
import POPULATE_QUOTE from './POPULATE_QUOTE'
import IMPORT_PRICE_LISTS from './IMPORT_PRICE_LISTS'
import ADD_PART from './ADD_PART'
import PART_PRICING from './PART_PRICING'
import ADD_ACTIVITY from './ADD_ACTIVITY'
import ADD_INVOICE from 'helpers/onboarding/skills/ADD_INVOICE'
import JOB_BOARD from './JOB_BOARD'
import SETUP_DELIVERIES from './SETUP_DELIVERIES'
import ADD_DELIVERY_NOTE from './ADD_DELIVERY_NOTE'

export const SKILLS = {
  HOME_COMPANY,
  ADD_CONTACT,
  IMPORT_CONTACTS,
  RAISE_QUOTE,
  POPULATE_QUOTE,
  IMPORT_PRICE_LISTS,
  ADD_PART,
  PART_PRICING,
  ADD_ACTIVITY,
  ADD_INVOICE,
  JOB_BOARD,
  SETUP_DELIVERIES,
  ADD_DELIVERY_NOTE,
}

export default SKILLS
